__turbopack_context__.v({
  "content": "Splash-module__yeTb2G__content",
  "inner": "Splash-module__yeTb2G__inner",
  "liquidMetal": "Splash-module__yeTb2G__liquidMetal",
  "root": "Splash-module__yeTb2G__root",
});
